// Environment configuration
export const config = {
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL || 'https://api.siis.ca',
  MONERIS_STORE_ID: process.env.REACT_APP_MONERIS_STORE_ID || '',
  MONERIS_API_TOKEN: process.env.REACT_APP_MONERIS_API_TOKEN || '',
} as const;
